<template>
  <div class="content">
    <div class="goods-section">
      <div class="g-header b-b"></div>
      <!-- 商品列表 -->
      <div class="g-item">
        <van-image lazy-load class="g-item-image" width="70" height="70" :src="preOrder.picture"></van-image>
        <div class="right">
          <span class="title clamp">{{preOrder.name}}</span>
          <span class="spec">讲师：{{preOrder.teacherName}}</span>
          <div class="price-box">
            <span class="price">¥{{preOrder.price}}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 金额明细 -->
    <div class="yt-list">
      <div class="yt-list-cell b-b">
        <span class="cell-tit clamp">商品金额</span>
        <span class="cell-tip">￥{{preOrder.amount}}</span>
      </div>
      <div class="yt-list-cell desc-cell">
        <span class="cell-tit clamp">备注</span>
        <input
          class="desc"
          style="text-align: right;"
          type="text"
          v-model="desc"
          placeholder="请填写备注信息"
          placeholder-class="placeholder"
        />
      </div>
    </div>
    <!-- 优惠明细 -->
    <div class="yt-list">
      <div v-if="preOrder.backPointNumber>0" class="yt-list-cell b-b" @click="toggleMask('show')">
        <div class="cell-icon">赠</div>
        <span class="cell-tit clamp">赠送积分</span>
        <span class="cell-tip active">{{preOrder.backPointNumber}}</span>
        <span class="cell-more wanjia wanjia-gengduo-d"></span>
      </div>
      <div v-if="preOrder.mostPointCanUse>0" class="yt-list-cell">
        <div class="cell-icon hb">抵</div>
        <span
          class="cell-tit clamp"
        >可最多使用{{preOrder.mostPointCanUse}}积分抵扣¥{{preOrder.mostPointCanUse/preOrder.howMuchPointIsOneYuan}}</span>
      </div>
      <div v-if="preOrder.mostPointCanUse>0" class="yt-list-cell">
        <div class="hb"></div>
        <span class="cell-tit clamp">抵扣积分数量</span>
        <input
          ref="points"
          v-model="inputMostPointCanUse"
          class="desc"
          @input="changePoints($event.target)"
          style="text-align: right;"
          type="number"
          placeholder="请输入抵扣积分数量"
          placeholder-class="placeholder"
        />
      </div>
      <div v-if="preOrder.memberDiscount>0" class="yt-list-cell">
        <div class="cell-icon lpk">折</div>
        <span class="cell-tit clamp">会员折扣</span>
        <span class="cell-tip">-￥{{preOrder.memberDiscount}}</span>
      </div>
      <div
        v-if="preOrder.couponStockList&&preOrder.couponStockList.length>0"
        class="yt-list-cell"
        @click="toggleCouponList"
      >
        <div class="cell-icon quan">券</div>
        <span class="cell-tit clamp">优惠券</span>
        <span class="cell-tip">{{this.couponPrice?'-¥'+this.couponPrice:'选择优惠券'}}</span>
      </div>
      <div
        v-if="preOrder.shoppingCardList&&preOrder.shoppingCardList.length>0"
        class="yt-list-cell"
        @click="toggleCardList"
      >
        <div class="cell-icon card">卡</div>
        <span class="cell-tit clamp">购物卡</span>
        <span class="cell-tip">{{this.cardIds&&this.cardIds.length>0?'已选择购物卡':'选择购物卡'}}</span>
      </div>
    </div>

    <!-- 底部 -->
    <div class="footer">
      <div class="price-content">
        <span>实付款</span>
        <div v-if="money>0" class="d-flex flex-row align-items-center">
          <span class="price-tip">￥</span>
          <span class="price">{{money}}</span>
        </div>
        <div v-else class="d-flex flex-row align-items-center">
          <span class="price-tip">￥</span>
          <span class="price">{{preOrder.amount}}</span>
        </div>
        <span v-if="inputMostPointCanUse*1>0">+</span>
        <div v-if="(inputMostPointCanUse*1)>0" class="d-flex flex-row align-items-center">
          <span class="price">{{inputMostPointCanUse*1}}</span>
          <span class="price-tip">积分</span>
        </div>
      </div>
      <span class="submit" @click="submit">提交订单</span>
    </div>

    <van-popup
      v-model="showCoupon"
      position="bottom"
      :style="{ maxHeight: '40%',
  background: '#f3f3f3'}"
      safe-area-inset-bottom
    >
      <my-coupon-own-list
        :fullNumber="preOrder.canUseCouponAmount"
        :couponList="preOrder.couponStockList"
        @reCoupon="reCoupon"
        @cancelCoupon="cancelCoupon"
      ></my-coupon-own-list>
    </van-popup>
    <van-popup
      v-model="showCardList"
      position="bottom"
      :style="{ maxHeight: '40%',
  background: '#f3f3f3'}"
      safe-area-inset-bottom
    >
      <my-shoppingcard-list
        :shopCardList="preOrder.shoppingCardList"
        @changeCardList="changeCardList"
      ></my-shoppingcard-list>
    </van-popup>
  </div>
</template>

<script>
import {
  mapState,
  mapMutations
} from 'vuex';
export default {
  data () {
    return {
      id: null,
      num: 0,
      maskState: 0, //优惠券面板显示状态
      desc: '', //备注
      payType: 1, //1微信 2支付宝
      couponList: [{
        title: '新用户专享优惠券',
        price: 5,
      },
      {
        title: '庆五一发一波优惠券',
        price: 10,
      },
      {
        title: '优惠券优惠券优惠券优惠券',
        price: 15,
      }
      ],
      preOrder: {},
      inputMostPointCanUse: '',
      inputMostMoneyCanUse: '',
      showCoupon: false,
      showCardList: false,
      couponStockId: null,
      couponPrice: 0,
      cardIds: [],
      cardPrice: 0
    }
  },
  created () {
    let query = this.$route.query
    if (query.id) {
      this.id = query.id * 1;
      this.marketingCampaignType = query.marketingCampaignType
      this.groupBuyGroupId = query.groupBuyGroupId
    }
    this.loadData()
  },
  computed: {
    ...mapState(['hasLogin', 'userInfo']),
    money () {
      let { freight, discountAmount } = this.preOrder
      freight = freight ? freight : 0
      let { inputMostMoneyCanUse, couponPrice, cardPrice } = this
      inputMostMoneyCanUse = inputMostMoneyCanUse ? inputMostMoneyCanUse : 0
      let money = discountAmount - couponPrice
      if (money < 0) {
        money = 0
      }
      money = money + freight - inputMostMoneyCanUse - cardPrice
      if (money < 0) {
        money = 0
      }
      return money
    }
  },
  methods: {
    toggleCouponList () {
      this.showCoupon = !this.showCoupon
    },
    toggleCardList () {
      this.showCardList = !this.showCardList
    },
    changeCardList (ids) {
      this.cardIds = ids
      this.cardPrice = 0;
      for (let card of this.preOrder.shoppingCardList) {
        if (this.cardIds.indexOf(card.id) > -1) {
          this.cardPrice += card.balance
        }
      }
    },
    reCoupon (coupon) {
      this.couponStockId = coupon.couponStockId
      this.couponPrice = coupon.denomination
    },
    cancelCoupon () {
      this.couponStockId = null
      this.couponPrice = 0
    },
    loadData () {
      this.getPreOrder()
    },
    numberChange (data) {
      this.number = data.number;
    },
    changePayType (type) {
      this.payType = type;
    },
    getPreOrder () {
      if (this.id != null) {
        //正常下单
        let params = {
          courseId: this.id
        }
        if (this.marketingCampaignType != null) {
          params.marketingCampaignType = this.marketingCampaignType
        }
        if (this.groupBuyGroupId != null) {
          params.groupBuyGroupId = this.groupBuyGroupId
        }
        this.$http.request(this.$http.pathMap.orderCoursePre,
          'get', params).then(res => {
            this.preOrder = res.data
          })
      }
    },

    //显示优惠券面板
    toggleMask (type) {
      let timer = type === 'show' ? 10 : 300;
      let state = type === 'show' ? 1 : 0;
      this.maskState = 2;
      setTimeout(() => {
        this.maskState = state;
      }, timer)
    },
    changePoints (target) {
      if (target.value) {
        if (target.value * 1 < this.preOrder.mostPointCanUse) {
          this.inputMostPointCanUse = target.value
        } else {
          this.inputMostPointCanUse = this.preOrder.mostPointCanUse
        }
        this.inputMostMoneyCanUse = this.inputMostPointCanUse / this.preOrder.howMuchPointIsOneYuan
        // console.log(this.inputMostPointCanUse)
      } else {
        this.inputMostMoneyCanUse = 0
      }
    },
    submit () {
      if (!this.userInfo.phone) {
        this.$router.push({
          path: '/pages/public/bindPhone'
        })
        return;
      }
      let params = {
        courseId: this.id,
        remark: this.desc,
        usePointNumber: this.inputMostPointCanUse * 1
      }
      if (this.marketingCampaignType != null) {
        params.marketingCampaignType = this.marketingCampaignType
      }
      if (this.groupBuyGroupId != null) {
        params.groupBuyGroupId = this.groupBuyGroupId
      }
      if (this.couponStockId != null) {
        params.couponStockId = this.couponStockId
      }
      if (this.cardIds && this.cardIds.length) {
        params.shoppingCardIds = this.cardIds
      }
      this.$http.request(this.$http.pathMap.orderCoudseSubmit, 'post', params).then(res => {
        this.$router.replace({
          path: '/pages/money/pay',
          query: {
            orderNo: res.data
          }
        })
      })
    },
    stopPrevent () { }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding-bottom: 50px;
}

.address-section {
  padding: 15px 0;
  background: #fff;
  position: relative;

  .order-content {
    display: flex;
    align-items: center;
  }

  .icon-shouhuodizhi {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    color: #888;
    font-size: 22px;
  }

  .cen {
    display: flex;
    flex-direction: column;
    flex: 1;
    font-size: 14px;
    color: $font-color-dark;
  }

  .name {
    font-size: 17px;
    margin-right: 12px;
  }

  .address {
    margin-top: 8px;
    margin-right: 10px;
    color: $font-color-light;
  }

  .icon-you {
    font-size: 16px;
    color: $font-color-light;
    margin-right: 15px;
  }

  .a-bg {
    position: absolute;
    left: 0;
    bottom: 0;
    display: block;
    width: 100%;
    height: 2px;
  }
}

.goods-section {
  margin-top: 8px;
  background: #fff;
  padding-bottom: 1px;

  .g-header {
    display: flex;
    align-items: center;
    height: 0;
    padding: 0 15px;
    position: relative;
  }

  .logo {
    display: block;
    width: 25px;
    height: 25px;
    border-radius: 100px;
  }

  .name {
    font-size: 15px;
    color: $font-color-base;
    margin-left: 12px;
  }

  .g-item {
    display: flex;
    margin: 10px 15px;

    .g-item-image {
      flex-shrink: 0;
      display: block;
      width: 70px;
      height: 70px;
      border-radius: 2px;
    }

    .right {
      flex: 1;
      padding-left: 12px;
      overflow: hidden;
    }

    .title {
      font-size: 15px;
      color: $font-color-dark;
    }

    .spec {
      font-size: 13px;
      color: $font-color-light;
    }

    .price-box {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: $font-color-dark;
      padding-top: 5px;

      .price {
        margin-bottom: 2px;
      }

      .number {
        font-size: 13px;
        color: $font-color-base;
        margin-left: 10px;
      }
    }

    .step-box {
      position: relative;
    }
  }
}

.yt-list {
  margin-top: 8px;
  background: #fff;
}

.yt-list-cell {
  display: flex;
  align-items: center;
  padding: 5px 15px 5px 20px;
  line-height: 35px;
  position: relative;

  &.cell-hover {
    background: #fafafa;
  }

  &.b-b:after {
    left: 15px;
  }

  .cell-icon {
    height: 16px;
    width: 16px;
    font-size: 11px;
    color: #fff;
    text-align: center;
    line-height: 16px;
    background: #f85e52;
    border-radius: 2px;
    margin-right: 6px;

    &.hb {
      background: #ffaa0e;
    }

    &.lpk {
      background: #3ab54a;
    }
    &.quan {
      background: #f56c6c;
    }
    &.card {
      background: blue;
    }
  }

  .cell-more {
    align-self: center;
    font-size: 12px;
    color: $font-color-light;
    margin-left: 5px;
    margin-right: -5px;
  }

  .cell-tit {
    flex: 1;
    font-size: 13px;
    color: $font-color-light;
    margin-right: 5px;
  }

  .cell-tip {
    font-size: 13px;
    color: $font-color-dark;

    &.disabled {
      color: $font-color-light;
    }

    &.active {
      color: $base-color;
    }

    &.red {
      color: $base-color;
    }
  }

  &.desc-cell {
    .cell-tit {
      max-width: 45px;
    }
  }

  .desc {
    flex: 1;
    font-size: $uni-font-size-base;
    color: $font-color-dark;
  }
}

/* 支付列表 */
.pay-list {
  padding-left: 20px;
  margin-top: 8px;
  background: #fff;

  .pay-item {
    display: flex;
    align-items: center;
    padding-right: 10px;
    line-height: 1;
    height: 55px;
    position: relative;
  }

  .icon-weixinzhifu {
    width: 40px;
    font-size: 20px;
    color: #6bcc03;
  }

  .icon-alipay {
    width: 40px;
    font-size: 20px;
    color: #06b4fd;
  }

  .icon-xuanzhong2 {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    font-size: 20px;
    color: $base-color;
  }

  .tit {
    font-size: 16px;
    color: $font-color-dark;
    flex: 1;
  }
}

.footer {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 995;
  display: flex;
  align-items: center;
  width: 100%;
  height: 45px;
  justify-content: space-between;
  font-size: 15px;
  background-color: #fff;
  z-index: 998;
  color: $font-color-base;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);

  .price-content {
    padding-left: 15px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .price-tip {
    color: $base-color;
    margin-left: 4px;
  }

  .price {
    font-size: 18px;
    color: $base-color;
  }

  .submit {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 100%;
    color: #fff;
    font-size: 16px;
    background-color: $base-color;
  }
}

/* 优惠券面板 */
.mask {
  display: flex;
  align-items: flex-end;
  position: fixed;
  left: 0;
  top: var(--window-top);
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0);
  z-index: 9995;
  transition: 0.3s;

  .mask-content {
    width: 100%;
    min-height: 30vh;
    max-height: 70vh;
    background: #f3f3f3;
    transform: translateY(100%);
    transition: 0.3s;
    overflow-y: scroll;
  }

  &.none {
    display: none;
  }

  &.show {
    background: rgba(0, 0, 0, 0.4);

    .mask-content {
      transform: translateY(0);
    }
  }
}

/* 优惠券列表 */
.coupon-item {
  display: flex;
  flex-direction: column;
  margin: 10px 12px;
  background: #fff;

  .con {
    display: flex;
    align-items: center;
    position: relative;
    height: 60px;
    padding: 0 15px;

    &:after {
      position: absolute;
      left: 0;
      bottom: 0;
      content: "";
      width: 100%;
      height: 0;
      border-bottom: 1px dashed #f3f3f3;
      transform: scaleY(50%);
    }
  }

  .left {
    display: flex;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    overflow: hidden;
    height: 50px;
  }

  .title {
    font-size: 16px;
    color: $font-color-dark;
    margin-bottom: 5px;
  }

  .time {
    font-size: 12px;
    color: $font-color-light;
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    color: $font-color-base;
    height: 50px;
  }

  .price {
    font-size: 22px;
    color: $base-color;

    &:before {
      content: "￥";
      font-size: 17px;
    }
  }

  .tips {
    font-size: 12px;
    color: $font-color-light;
    line-height: 30px;
    padding-left: 15px;
  }

  .circle {
    position: absolute;
    left: -3px;
    bottom: -5px;
    z-index: 10;
    width: 10px;
    height: 10px;
    background: #f3f3f3;
    border-radius: 100px;

    &.r {
      left: auto;
      right: -3px;
    }
  }
}
</style>
